/**
 *
 * Created Date: 2019-06-06, 00:01:45 (zhenliang.sun)
 * Last Modified: 2019-08-14, 14:34:41 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 *
 *
 * @export
 * @class Stage
 * @author zhenliang.sun
 */
export default class Stage {
  constructor(root) {
    this.root = root;
  }

  /**
   * 立即渲染画布
   */
  renderNow() {
    this.root.renderAll();
  }

  /**
   * 设置舞台大小并且在下一帧进行渲染
   * @param {*} w 新的宽度
   * @param {*} h 新的高度
   */
  setSize(w, h) {
    this.root.setDimensions({
      width: w,
      height: h
    });
    this.renderNow();
  }

  /**
   * 获取canvas的宽度
   */
  getStageWidth() {
    return this.root.getWidth();
  }

  /**
   * 获取canvas的高度
   */
  getStageHeight() {
    return this.root.getHeight();
  }

  deselectAll() {
    if (this.root.getActiveObject()) {
      this.root.discardActiveObject();
      this.root.renderAll();
    }
  }
}
